var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHeartIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16.064 10.162 1.607-1.607a6.023 6.023 0 0 1 8.518 0 6.241 6.241 0 0 1 .154 8.667l-9.547 10.252a1 1 0 0 1-1.463 0L5.785 17.222a6.241 6.241 0 0 1 .155-8.667 6.023 6.023 0 0 1 8.518 0l1.606 1.607z"
})));
export default SvgHeartIcon;